import React, { useEffect, useState } from "react";
import axiosInstance from "../config/axiosConfig";
import { formatDate } from "../utils/utils";

const CobranzaReajusteModal = ({ visible, onClose, pacientes, onSuccess }) => {
    const [observacion, setObservacion] = useState("");
    const [aplicando, setAplicando] = useState(false);
    const [resultados, setResultados] = useState(null);

    useEffect(() => {
        if (visible) {
            setObservacion("");
            setResultados(null);
        }
    }, [visible]);

    if (!visible) return null;

    const mensajePorPaciente = (pacienteID) => resultados?.find(r => r.pacienteID === pacienteID);

    const aplicarTodos = async () => {
        setAplicando(true);
        try {
            const datos = pacientes.map(p => ({ pacienteID: p.paciente_id, fecha: p.fecha_reajuste_a_avisar }));
            const resp = await axiosInstance.post("/paciente/reajuste-familia/aplicar-masivo", { datos, observacion });
            if (resp.data?.error) throw new Error(resp.data.message || "No se pudo aplicar el reajuste.");
            setResultados(resp.data.data || []);
            if (onSuccess) onSuccess();
        } catch (error) {
            alert(error.response?.data?.message || error.message || "Error al aplicar reajuste.");
        } finally {
            setAplicando(false);
        }
    };

    const totalAplicados = resultados ? resultados.filter(r => r.exito).length : 0;
    const totalErrores = resultados ? resultados.filter(r => !r.exito).length : 0;

    return (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header bg-success">
                        <h5 className="modal-title text-white">
                            <i className="bi bi-arrow-up-circle me-2"></i> Aplicar reajuste de valores
                        </h5>
                        <button className="btn-close" onClick={onClose} disabled={aplicando}></button>
                    </div>
                    <div className="modal-body">
                        {!resultados && (
                            <>
                                <p className="text-muted small">
                                    Estos pacientes tienen su reajuste semestral previsto para el periodo actual.
                                    Solo se aplicaran los valores que ya fueron programados en <strong>Reajuste Valores Familia</strong>;
                                    los que no tengan valores programados quedaran marcados como omitidos.
                                </p>
                                <div className="table-responsive mb-3" style={{ maxHeight: 320 }}>
                                    <table className="table table-sm table-bordered align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Paciente</th>
                                                <th>RUT</th>
                                                <th className="text-center">Reajuste previsto</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pacientes.map(p => (
                                                <tr key={p.paciente_id}>
                                                    <td>{p.nombre_paciente}</td>
                                                    <td>{p.rut}</td>
                                                    <td className="text-center">
                                                        {p.fecha_reajuste_a_avisar ? formatDate(p.fecha_reajuste_a_avisar) : "-"}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="mb-2">
                                    <label className="form-label fw-bold">Observación (opcional)</label>
                                    <input
                                        className="form-control"
                                        value={observacion}
                                        onChange={e => setObservacion(e.target.value)}
                                        placeholder="Motivo o comentario"
                                        disabled={aplicando}
                                    />
                                </div>
                            </>
                        )}

                        {resultados && (
                            <>
                                <div className="alert alert-info">
                                    {totalAplicados} paciente(s) aplicado(s), {totalErrores} omitido(s) o con error.
                                </div>
                                <div className="table-responsive" style={{ maxHeight: 320 }}>
                                    <table className="table table-sm table-bordered align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Paciente</th>
                                                <th>RUT</th>
                                                <th>Resultado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pacientes.map(p => {
                                                const r = mensajePorPaciente(p.paciente_id);
                                                return (
                                                    <tr key={p.paciente_id}>
                                                        <td>{p.nombre_paciente}</td>
                                                        <td>{p.rut}</td>
                                                        <td>
                                                            {r?.exito ? (
                                                                <span className="badge bg-success">Aplicado</span>
                                                            ) : (
                                                                <span className="badge bg-secondary" title={r?.mensaje}>Omitido</span>
                                                            )}
                                                            {!r?.exito && r?.mensaje && (
                                                                <div className="text-muted small">{r.mensaje}</div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose} disabled={aplicando}>
                            {resultados ? "Cerrar" : "Cancelar"}
                        </button>
                        {!resultados && (
                            <button className="btn btn-success" onClick={aplicarTodos} disabled={aplicando || pacientes.length === 0}>
                                {aplicando ? "Aplicando..." : `Aplicar a ${pacientes.length} paciente(s)`}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CobranzaReajusteModal;
